export default "__VITE_ASSET__CFQ5gupX__";